import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PlanningOverviewComponent } from './planning-overview/planning-overview.component';

export const routes: Routes = [
    { path: '', redirectTo: 'overview', pathMatch: 'full' },
    { path: 'overview', component: PlanningOverviewComponent },
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
